import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { useParam, useParamProps } from '@/composables/params';
import { ParamSlider } from '@/models/enums/WidgetEnum';
import { isNil } from '@/utils/misc';
import { abbreviateNumber } from '@/utils/number';
import { computed, watch } from 'vue';

// props.paramValue is of type Record<number, number> where the key is the index of the slider tick and the value is
// the value of the tick. The emitted data has the same schema.
// This value is transformed in this component to [number, number] because that's the type of value expected by the
// the Buefy slider component

/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SliderParam',
  props: useParamProps<ParamSlider, Record<number, number>>(),
  emits: ["update"],
  setup(__props, { emit }: { emit: ((e: 'update', value: { [key: string]: Record<number, number> }) => void), expose: any, slots: any, attrs: any }) {

const props = __props;





const { label, emitValue } = useParam(props, emit);
const { t } = useI18n();

function sendUpdate(newRangeIndices: number[]) {
  if (newRangeIndices !== rangeIndices.value) {
    emitValue(
      Object.fromEntries(
        newRangeIndices.map((index) => [index, tickIndexToValue(index)]),
      ),
    );
  }
}

function tickIndexToValue(tickIndex: number) {
  return props.paramInfo.tickValues[tickIndex];
}

function formatNumber(tickIndex: number) {
  return abbreviateNumber(tickIndexToValue(tickIndex));
}

function isFullRangeSelected(oldParams: ParamSlider): boolean {
  return (
    rangeIndices.value[0] === 0 &&
    rangeIndices.value[1] === oldParams.tickValues.length - 1
  );
}

watch(
  () => props.paramInfo,
  (newParams, oldParams) => {
    if (isFullRangeSelected(oldParams)) {
      sendUpdate([rangeIndices.value[0], maxTickIndex.value]);
    } else {
      const maxIndex =
        rangeIndices.value[1] <= maxTickIndex.value
          ? rangeIndices.value[1]
          : maxTickIndex.value;
      const minIndex =
        rangeIndices.value[0] < maxIndex ? rangeIndices.value[0] : maxIndex - 1;
      sendUpdate([minIndex, maxIndex]);
    }
  },
);

const rangeIndices = computed(() => {
  if (!isNil(props.paramValue)) {
    return Object.keys(props.paramValue).map((x) => Number(x));
  }

  return (
    props.paramInfo.defaultValue ?? [minTickIndex.value, maxTickIndex.value]
  );
});

// This could be a regular const, but I'll leave it like this so that the code
// looks more consistent (otherwise the code would be [minTickIndex, maxTickIndex.value])
const minTickIndex = computed(() => 0);

const maxTickIndex = computed(() => props.paramInfo.tickValues.length - 1);

return { __sfc: true,props, emit, label, emitValue, t, sendUpdate, tickIndexToValue, formatNumber, isFullRangeSelected, rangeIndices, minTickIndex, maxTickIndex }
}

})